import React, { useContext, useMemo } from 'react';
import { LabelsContext } from 'contextProviders/SplashScreenProviders/ContentProviders/LabelsProvider';
import Dropdown from './Dropdown';
import Badge from '../../kingpin/atoms/Badge';
import FleetOpsStaffOnly from '../Common/FleetOpsStaffOnly';
import Tooltip from '../Tooltip';

const LabelsPicker = ({
  labelIds,
  setLabelIds,
}: {
  labelIds: string[];
  setLabelIds: React.Dispatch<React.SetStateAction<string[]>>;
}) => {
  const { labels } = useContext(LabelsContext);

  const options = useMemo((): DropdownOption[] => {
    return labels.map((l) => ({
      key: l.id,
      label: l.name,
      renderLabel: () => (
        <div style={{ paddingRight: 16 }}>
          <Badge badgeType={l.color} text={l.name} />
        </div>
      ),
      isSelected: labelIds.includes(l.id),
      onSelected: () => {
        setLabelIds((currentLabelIds) => {
          if (currentLabelIds.includes(l.id)) {
            return currentLabelIds.filter((l2) => l2 !== l.id);
          }
          return [...currentLabelIds, l.id];
        });
      },
    }));
  }, [labelIds, labels, setLabelIds]);

  return (
    <FleetOpsStaffOnly
      fallback={
        <Tooltip content="This setting is only available to FleetOps Staff">
          <Dropdown
            options={options}
            isMulti
            placeholder={'Select labels...'}
            isDisabled
          />
        </Tooltip>
      }
    >
      <Dropdown options={options} isMulti placeholder={'Select labels...'} />
    </FleetOpsStaffOnly>
  );
};

export default LabelsPicker;
